<!--
  Modules built upon the ModalOverlayModule are:
    - ModalCardModule

  If any changes are made to this file, ENSURE that it does not break the above modules,
  or that the above modules are updated accordingly.
 -------------------------------------------------------------------------------------------
  Include the following in your main.js file for this module to work properly:
    import vClickOutside from 'v-click-outside'
    Vue.use(vClickOutside)

  EXAMPLE USE CASE:
   <modal-overlay v-show="showModal" :showModal.sync="showModal" @modal-close="closeCal">
      <div></div>
   </modal-overlay>
-->
<template>
  <div class="modal-overlay display-flex align-center justify-around w100p h100p pos-fixed top0 left0 z-999999" v-if="showModal">
    <div class="slot-container inline-block z-999999">
      <slot></slot>
    </div>
    <div class="background-overlay pos-abs w100p h100p" v-on="{ ...getEvents }">
    </div>
  </div>
</template>
<script>
export default {
  name: 'bh-modal-overlay',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    disableOutSideClick: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getEvents() {
      return {
        ...this.disableOutSideClick ? { click: this.closeModal } : {}
      }
    },
    closeModal() {
      this.$emit('update:showModal', false)
      this.$emit('modal-close', true)
    }
  }
}
</script>
